module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Im0wIDBoMjB2MjBoLTIweiIvPjxwYXRoIGQ9Im0xMyA0djIuNGgtMS4yYy0uNDE0IDAtLjYuNDg2LS42Ljl2MS41aDEuOHYyLjRoLTEuOHY0LjhoLTIuNHYtNC44aC0xLjh2LTIuNGgxLjh2LTIuNGMwLTEuMzI1NDgzNCAxLjA3NDUxNjYtMi40IDIuNC0yLjR6IiBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook-icon.svg
// module id = iAfZ
// module chunks = 0